<script>
import { getCouponHistory } from 'dygc'

export default {
  name: "HistoryCoupon",
  props: {
    userOpenId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      show: false,
      loading: false,
      records: []
    }
  },
  mounted() {
    this.show = true
    this.loading = true
    this.$bus.openLoading()
    this.getList().finally(() => {
      this.loading = false
      this.$bus.closeLoading()
      var myScroll = new IScroll(this.$refs.scrollRef, {
        mouseWheel: true,
        // scrollbars: true
      });
    })
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    getList() {
      const getTips = (data) => {
        // const texts = data.deviceType.map(type=>{
        //   switch (type) {
        //     case "HENG_ZHONG_ICE":
        //       return "冰淇淋机"
        //     case "HENG_ZHONG_SUGAR":
        //       return "棉花糖机"
        //   }
        // })
        return `仅限${data.deviceTypeText}使用`
      }
      return getCouponHistory(this.userOpenId || "test").then((res) => {
        this.records = (res.data || []).map(item => {
          return {
            ...item,
            amount: item.amount / 100,
            tips: getTips(item)
          }
        })
      })
    }
  },
}
</script>

<template>
  <van-overlay show z-index="1000" class-name="">
    <van-popup v-model="show" position="bottom"
      :style="{ height: '90%', overflow: 'auto', 'border-radius': '16px 16px 0 0' }" :close-on-click-overlay="false">
      <div class="h-full flex flex-col">
        <div class="py-3 relative">
          <div class="text-center">
            <span class="text-large">历史优惠券</span>
          </div>
          <div class="absolute" style="top: 12px; right: 12px;">
            <van-icon name="cross" @click="onClose" class="text-large" />
          </div>
        </div>
        <div class="history-content flex-1 pt-3">
          <div ref="scrollRef" class="h-full overflow-y-hidden">
            <van-list v-model="loading" :finished="true" finished-text="没有更多了">
              <div v-for="item in records" :key="item.id" class="mb-3 last:mb-0">
                <div class="history-item validity" :class="{ 'invalid': item.status !== 0 }">
                  <div class="history-item__left">
                    <div>
                      <span>¥</span>
                      <span style="font-size: 38px;">{{ item.amount }}</span>
                    </div>
                  </div>
                  <div class="history-item__right">
                    <div class="h-full flex justify-between items-center">
                      <div class="flex flex-col justify-between h-full">
                        <div class="history-item__code">
                          <template v-if="item.fromOtherAnswer">
                            {{ item.remoteCouponCode }}
                          </template>
                          <template v-else>
                            <span style="font-size: 12px;line-height: 14px;">自动使用优惠卷</span>
                          </template>
                          
                        </div>
                        <div class="history-item__time">
                          <div>有效期至：</div>
                          <div>
                            {{ item.validityTime }}
                          </div>
                        </div>
                        <div class="history-item__tips">
                          <span>{{ item.tips }}</span>
                        </div>
                      </div>
                      <div>
                        <img v-if="item.status === 0" src="~@/assets/img/answer/coupon/wgq.png" alt="" width="60">
                        <img v-else-if="item.status == 1" src="~@/assets/img/answer/coupon/ysy.png" alt="" width="60">
                        <img v-else-if="item.status == 2" src="~@/assets/img/answer/coupon/ygq.png" alt="" width="60">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </div>
        </div>
      </div>
    </van-popup>
  </van-overlay>
</template>

<style lang="scss" scoped>
.history-content {
  background: #F5F5F5;
  height: 0;

  .history-item {
    min-height: 110px;
    width: 351px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-size: contain;
    display: flex;
    background-size: 100% 100%;

    &.validity {
      background-image: url("~@/assets/img/answer/coupon/coupon-bg-1.png");
    }

    &.invalid {
      background-image: url("~@/assets/img/answer/coupon/coupon-bg-2.png");
    }

    &__left {
      width: 110px;
      font-weight: 600;
      color: #FFFFFF;
      text-align: center;
      line-height: 52px;

      &>div {
        padding-top: 12px;
      }
    }

    &__right {
      flex: 1;
      width: 0;
      padding: 16px 12px;
    }

    &__code {
      font-weight: 600;
      font-size: 24px;
      color: rgba($color: #000000, $alpha: 0.9);
      line-height: 32px;
    }

    &__time {
      font-weight: 400;
      font-size: 12px;
      color: rgba($color: #000000, $alpha: 0.9);
      line-height: 18px;
    }

    &__tips {
      font-weight: 400;
      font-size: 12px;
      color: rgba($color: #000000, $alpha: 0.45);
      line-height: 18px;
    }
  }
}
</style>